export default {
  getAccountFullName(state) {
    return `${state.info?.firstName} ${state.info?.lastName}`;
  },
  getPurlId(state) {
    return state.id;
  },
  getAccountFirstName(state) {
    return `${state.info?.first_name}`;
  },
  getAccountName(state) {
    return state.info?.accountName;
  },
  getAccountRep(state) {
    return state.info?.rep;
  },
  getAccounts(state) {
    return state.info.accounts;
  },
  getAccount(state) {
    return state.info;
  },
  getLetterVersion(state) {
    return state.info.accounts?.map((x) => x.letterVersion);
  },
};
